import React, { Component } from "react";
import AuthService from "../session/AuthService";
import FriendsFinder from "../api/FriendsFinder";
import { withTranslation } from "react-i18next";
import i18n from "../i18n";
import { withRouter } from "react-router";
import ForumService from "../api/ForumService";
import dummyimage from "../img/avatar_dummy.png";
import banner from "../img/banner.png";
import ProfileService from "../api/ProfileService";
import MSDeepLink from "../utils/MSDeepLink";
import { connect } from "react-redux";
import FriendProfile from "../screens/Home/ProfileFriends/FriendProfile";
import { API_URL } from "../config/app-config";
import { FaTags } from "react-icons/fa";
import { setSelectedUserAction } from "../redux/actions/chatActions";
import { premiumUser } from "../utils";
import { IoChatboxEllipsesOutline } from "react-icons/io5";

class FriendsOnYuukkeCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      coverPhoto: "",
      userPhoto: "",
    };
    this.getCoverPhoto = this.getCoverPhoto.bind(this);
    this.getBase64String = this.getBase64String.bind(this);
    this.showFriendsProfile = this.showFriendsProfile.bind(this);
    this.chatNow = this.chatNow.bind(this);
  }

  componentDidMount() {
    let langValue = AuthService.getCommonLanguages();
    i18n.changeLanguage(langValue);
    this.load(this.props.userId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userId !== this.props.userId) {
      this.load(this.props.userId);
    }
  }

  showFriendsProfile(userId, userPhoto) {
    this.props.history.push(
      `/${this.props.workspaceType}/friendDescription/${userId}`,
      { from: window.location.pathname, profile: userPhoto }
    );
  }

  load(data) {
    this.getBase64String(data);
    this.getCoverPhoto(data);
  }

  chatNow(user_id, username, userType, profilePhoto, e) {
    e.stopPropagation();
    const data = {
      userId: user_id,
      userName: username,
      userType: userType,
      profilePhoto: profilePhoto,
    };
    this.props.setSelectedUserAction(data);
  }

  getCoverPhoto(uid) {
    const coverPhoto = { userId: uid };
    const response = ForumService.getUserCoverPhotoCache(coverPhoto);

    if (response?.data?.data?.coverPhoto) {
      this.setState({ coverPhoto: response.data.data.coverPhoto });
    } else {
      ProfileService.getUsercoverPhoto(coverPhoto)
        .then((response) => {
          ForumService.setUserCoverPhotoCache(coverPhoto, response);
          if (response?.data?.data?.coverPhoto) {
            this.setState({ coverPhoto: response.data.data.coverPhoto });
          }
        })
        .catch(console.error);
    }
  }

  getBase64String(userId) {
    const getBase64String = { userId };
    const response = ForumService.getUserPhotoCache(getBase64String);

    if (response?.data?.data?.userPhoto) {
      this.setState({ userPhoto: response.data.data.userPhoto });
    } else {
      ForumService.getUserPhoto(getBase64String)
        .then((response) => {
          ForumService.setUserPhotoCache(getBase64String, response);
          if (response?.data?.data?.userPhoto) {
            this.setState({ userPhoto: response.data.data.userPhoto });
          }
        })
        .catch(console.error);
    }
  }

  render() {
    const { t } = this.props;
    const { userId, name, premiumData, profession } = this.props;
    const { coverPhoto, userPhoto } = this.state;

    console.log("FriendsOnYuukkeCard props :", this.props);

    // Card styling
    const cardStyle = {
      // width: "85%",
      width: "100%",
      borderRadius: "10px",
      overflow: "hidden",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      backgroundColor: "#ffffff",
      marginBottom: "16px",
      position: "relative",
      cursor: "pointer",
      transition: "all 0.2s ease",
      // height: "200px",
      // height: "200px",
      margin: "auto",
    };

    const bannerStyle = {
      height: "80px",
      width: "100%",
      // objectFit: "cover",
      objectFit: "contain",
      backgroundColor: "#000000",
    };

    const avatarContainerStyle = {
      position: "relative",
      display: "flex",
      justifyContent: "center",
      // marginTop: "-40px",
      marginTop: "-20px",
      marginBottom: "10px",
      position: "relative",
      paddingInlineStart: "15px",
      // border: "1px solid ",
      alignItems: "flex-end",
    };

    const msgIcon = {
      position: "absolute",
      right: "20px",
      bottom: "5px",
      color: "#1877f2",
    };

    const avatarStyle = {
      // width: "70px",
      // height: "70px",
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      border: "3px solid white",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      objectFit: "cover",
      backgroundColor: "#fff",
      // border: "1px solid red",
    };

    const nameStyle = {
      // fontSize: "16px",
      fontSize: "14px",
      fontWeight: "600",
      margin: "0 0 10px",
      color: "#050505",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      padding: "0 10px",
    };

    const contentStyle = {
      display: "flex",
      padding: "0 12px 5px 12px",
      // textAlign: "center",
      // justifyContent: "center",
      alignItems: "center",
      // alignItems: "flex-end",
      // border: "1px solid green",
    };

    const profName = {
      // fontSize: "16px",
      fontSize: "12px",
      fontStyle: "light",
      // margin: "0 0 10px",
      color: "#8d0000",
      // color: "grey",
      textAlign: "start",
      // whiteSpace: "nowrap",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      padding: "0 10px",
    };

    const buttonStyle = {
      backgroundColor: "#e7f3ff",
      color: "#1877f2",
      border: "none",
      borderRadius: "6px",
      // padding: "8px 16px",
      padding: "4px 8px",
      marginTop: '3px !important',
      // fontSize: "14px",
      fontSize: "12px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "background-color 0.2s",
      // width: "100%",
      // maxWidth: "140px",
      // maxWidth: "140px",
      width: "fit-content",
      // margin: "0 auto",
      // margin: "0 auto",
      // border: "1px solid red",
      // marginLeft: "auto",
    };

    const premiumBadgeStyle = {
      position: "absolute",
      bottom: "2px",
      right: "2px",
      backgroundColor: "#FFD700",
      borderRadius: "50%",
      width: "20px",
      height: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "12px",
      fontWeight: "bold",
      color: "#000",
    };

    return (
      <div
        className="friend-card"
        style={cardStyle}
        onMouseEnter={(e) =>
          (e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.15)")
        }
        onMouseLeave={(e) =>
          (e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.1)")
        }
        onClick={() => this.showFriendsProfile(userId, userPhoto)}
      >
        <img
          style={bannerStyle}
          src={coverPhoto ? API_URL + "auth/image/" + coverPhoto : banner}
          alt={name}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = banner;
          }}
        />

        <div style={avatarContainerStyle}>
          <img
            style={avatarStyle}
            src={userPhoto ? API_URL + "auth/image/" + userPhoto : dummyimage}
            onError={({ currentTarget }) => {
              currentTarget.onerror = null;
              currentTarget.src = dummyimage;
            }}
            alt={name}
          />
          {premiumData && premiumUser(premiumData) && (
            <div style={premiumBadgeStyle} title="Premium User">
              ★
            </div>
          )}
          <h3 style={nameStyle}>{name}</h3>

          <div style={contentStyle}>

            <div
              style={buttonStyle}
              onClick={(e) => this.chatNow(userId, name, 1, userPhoto, e)}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = "#dbe7f2")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = "#e7f3ff")
              }
            >

              <IoChatboxEllipsesOutline size={"18px"} />
            </div>
          </div>

          {/* 
          <IoChatboxEllipsesOutline
            size={"30px"}
            style={msgIcon}
            color="orange"
          /> */}
        </div>

        <div style={contentStyle}>
          {/* <h3 style={nameStyle}>{name}</h3> */}
          {profession && profession.trim() !== '' && (
            <div style={profName}>#{profession.trim()}</div>
          )}


          {/* <div
            style={buttonStyle}
            onClick={(e) => this.chatNow(userId, name, 1, userPhoto, e)}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#dbe7f2")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#e7f3ff")
            }
          >
            {t("MESSAGE")}
            {t("Chat")}

            <IoChatboxEllipsesOutline size={"18px"} />
          </div> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    workspaceType: state.loginDetailsApi.loginDetails.userWorkSpace?.slug,
  };
};

const mapDispacthToProps = (dispatch) => {
  return {
    setSelectedUserAction: (id) => dispatch(setSelectedUserAction(id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispacthToProps
)(withTranslation()(withRouter(FriendsOnYuukkeCard)));
